import cntl from "cntl";
import PropTypes from "prop-types";
import { useState, useRef, useEffect } from "react";
import DropdownButton from "@dbox/components/atoms/DropdownButton";
import { DropdownCard } from "@dbox/components";
import DropdownCardThreeDoots from "../molecules/DropdownCardThreeDoots";
import { IconDotsVertical } from "@tabler/icons-react";

const propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  options: PropTypes.array.isRequired,
  openDropdownTo: PropTypes.oneOf(["left", "right"]).isRequired,
};

function ThreeDoots({ onAction, className, options, openDropdownTo }) {
  const dropdownRef = useRef();
  const [dropdownOpened, setDropdownOpened] = useState(false);
  const [elementIndexClicked, setElementIndexClicked] = useState(null);

  const buttonCn = () => cntl`
    h-5
    w-5
    hover:cursor-pointer
  `;

  const dropdownCn = (dropdownOpened) => cntl`
    absolute
    z-10
    mt-1
    w-64
    p-3
    pb-0
    shadow
    rounded-lg
    bg-white
    border border-solid border-grey-300
    ${dropdownOpened ? `visible` : `hidden`}
    ${openDropdownTo === `left` ? `right-0` : `left-0`}
  `;

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  const handleClickOutside = (e) => {
    if (!dropdownRef?.current?.contains(e.target)) {
      setDropdownOpened(false);
    }
  };

  const selectionToggle = (currentElementIndexClicked) => {
    if (
      currentElementIndexClicked !== undefined &&
      currentElementIndexClicked !== null
    ) {
      setElementIndexClicked((prevElementIndexClicked) => {
        if (prevElementIndexClicked !== currentElementIndexClicked) {
          return currentElementIndexClicked;
        } else {
          return null;
        }
      });
    }
  };

  const onOptionClick = (onClick, currentElementIndexClicked) => {
    onAction(onClick());
    setDropdownOpened(false);
    selectionToggle(currentElementIndexClicked);
  };

  return (
    <div className={className ? className : undefined} ref={dropdownRef}>
      <DropdownButton
        classNameDropdownBtn={buttonCn(dropdownOpened)}
        onClickDropdownBtn={() => setDropdownOpened(!dropdownOpened)}
        iconDropdownBtn={<IconDotsVertical className="text-grey-500" />}
      />
      <DropdownCard classNameDropdownCard={dropdownCn(dropdownOpened)}>
        <DropdownCardThreeDoots
          options={options}
          onOptionClick={onOptionClick}
          elementIndexClicked={elementIndexClicked}
        />
      </DropdownCard>
    </div>
  );
}

ThreeDoots.propTypes = propTypes;
export default ThreeDoots;
